import { MdChevronLeft } from 'react-icons/md';
import { useHistory } from 'react-router-dom';

import { Container, ItemMenu, TextItem } from './styles';

function PolicyMenu() {
  const history = useHistory();

  return (
    <Container>
      <ItemMenu
        onClick={() => {
          history.push('/minhas-apolices');
        }}
      >
        <MdChevronLeft size="18" />
        <TextItem>Minhas apólices</TextItem>
      </ItemMenu>
    </Container>
  );
}

export default PolicyMenu;
